import detailsActions from './actions';
import productsActions from './loadProducts';

export default {
  ...detailsActions,
  ...productsActions
};
